// Layout and colour the two rate grids share — the editable one in step 2 and
// the read-only one in the preview. Kept out of `RateGridPrimitives` so that
// file exports only components and stays fast-refreshable.
import { TRoomCol } from "./utils"

// The grid is laid out on `table-layout: auto` with no width of its own, so the
// rate columns settle around the rate input (7rem, see RateInputField) instead
// of splitting whatever width the parent happens to have. The first column is
// sticky and holds the longest text, so it is pinned to a fixed width rather
// than left to grow with the room names.
export const ROOM_OCCUPANCY_COL_WIDTH = "25rem"
export const RATE_COL_MIN_WIDTH = "7rem"

// Hairline between cells. Light enough that the sticky column's own background
// still reads as continuous with the row it belongs to.
export const GRID_BORDER_COLOR = "#F0F0F3"

// Cells a room cannot be sold at are struck out of the grid entirely rather
// than left blank, so an empty cell always means "not priced yet".
export const NOT_SELLABLE_BACKGROUND =
	"repeating-linear-gradient(45deg, #f8fafc, #f8fafc 6px, #f1f5f9 6px, #f1f5f9 12px)"

// Tint behind a sellable rate cell, holding the grid's rows apart from the
// not-sellable hatching without reading as a highlight.
export const RATE_CELL_BACKGROUND = "#FAFFFD"

// The pill behind a column header. Colour carries the pax type: the room's own
// occupancies in cyan, the base and adult columns in blue, children split so a
// bed-less child (CNB) cannot be mistaken for one with a bed (CWEB).
export const COLUMN_PILL_COLORS = {
	lower: { backgroundColor: "#ECFEFF", color: "#007595" },
	base: { backgroundColor: "#F0F9FF", color: "#0069A8" },
	cnb: { backgroundColor: "#FAF5FF", color: "#8200DB" },
	cweb: { backgroundColor: "#F5F7FF", color: "#0700DB" },
} as const

export type TColumnPillVariant = keyof typeof COLUMN_PILL_COLORS

export function columnPillVariant(col: Pick<TRoomCol, "paxType">) {
	if (col.paxType === "AWEB") return "base"
	return col.paxType === "CNB" ? "cnb" : "cweb"
}
